import ComentariosPreguntasService from "@/api/secciones/comentarios_preguntas";

const ComentarioPreguntaStore = {
  state: {
    comentarioPreguntaList: [],
    form: {},
  },
  mutations: {
    SET_COMENTARIO_PREGUNTA: (state, payload) => (state.form = payload),
    SET_COMENTARIO_PREGUNTA_LIST: (state, list) => (state.comentarioPreguntaList = list),
  },
  actions: {
    async getComentarioPreguntaList({ dispatch }, { search, page, pageSize }) {
      const res = await ComentariosPreguntasService.list(search, page, pageSize);

      switch (res.status) {
        case 401:
          dispatch("redirect", "/auth/login");
          break;
        case 404:
          dispatch("redirect", "/");
          break;
        default:
          return res;
      }
    },
    setComentarioPregunta({ commit }, payload) {
      commit("SET_COMENTARIO_PREGUNTA", payload);
    },
    async saveComentarioPregunta({ dispatch }, payload) {
      const res = payload?.id
        ? await ComentariosPreguntasService.edit(payload)
        : await ComentariosPreguntasService.create(payload);

      switch (res.status) {
        case 401:
          dispatch("redirect", "/auth/login");
          break;
        case 404:
          dispatch("redirect", "/");
          break;
        default:
          return res;
      }
    },
    async getComentarioPreguntaById({ dispatch }, { id }) {
      const res = await ComentariosPreguntasService.getById({ id });

      switch (res.status) {
        case 401:
          dispatch("redirect", "/auth/login");
          break;
        case 404:
          dispatch("redirect", "/");
          break;
        default:
          break;
      }

      return res;
    },
    setComentarioPreguntaList({ commit }, list) {
      commit("SET_COMENTARIO_PREGUNTA_LIST", list);
    },
    async deactivateComentarioPregunta({ dispatch }, { id }) {
      const res = await ComentariosPreguntasService.deactivate({ id });

      switch (res.status) {
        case 401:
          dispatch("redirect", "/auth/login");
          break;
        case 404:
          dispatch("redirect", "/");
          break;
        default:
          return res;
      }
    },
  },
  getters: {
    getComentarioPregunta: (state) => state.form,
    getComentarioPreguntaListState: (state) => state.comentarioPreguntaList,
  },
};

export default ComentarioPreguntaStore;
